import { atomWithStorage } from "jotai/utils";

export type ThemePreset = 'default' | 'catppuccin-mocha' | 'catppuccin-macchiato' | 'catppuccin-frappe' | 'catppuccin-latte';

export const themePresetAtom = atomWithStorage<ThemePreset>("settings_themePreset", "default");
export const customAccentColorAtom = atomWithStorage<string>("settings_customAccentColor", "");
export const customBackgroundColorAtom = atomWithStorage<string>("settings_customBackgroundColor", "");
export const transparentBackgroundAtom = atomWithStorage<boolean>("settings_transparentBackground", true);
export const spectrogramAutoThemeColorAtom = atomWithStorage<boolean>("settings_spectrogramAutoThemeColor", false);
